import { StyledEngineProvider, ThemeProvider } from "@mui/material";
import { WebgateProvider } from "@xvia/webgate-connect";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import "./styles/main.scss";
import { theme } from "./styles/theme";

const baseName = window.__APP_BASE__ ?? "/";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter basename={baseName}>
      <WebgateProvider portalUrl={process.env.PORTAL_URL as string}>
        <ThemeProvider theme={theme}>
          <StyledEngineProvider injectFirst={true}>
            <App />
          </StyledEngineProvider>
        </ThemeProvider>
      </WebgateProvider>
    </BrowserRouter>
  </React.StrictMode>
);
